import { useQuery } from '@tanstack/react-query';
import { versionCheckQueryOptions } from './version.query-options';

/**
 * 버전 체크 query 훅 — `versionCheckQueryOptions`(SSOT)를 React 컨텍스트에 적용.
 * 화면 포커스마다 재검사(전역 `refetchOnWindowFocus`). 강제/넛지 업데이트 UI 의 데이터 소스.
 */
export function useVersionCheckQuery() {
  return useQuery(versionCheckQueryOptions());
}
